export function isColorAttribute(attribute?: { name: string; slug: string } | null): boolean {
  if (!attribute) return false;
  const key = (attribute.slug || attribute.name).trim().toLowerCase();
  return key === 'colour' || key === 'color';
}

export function isFormatAccessAttribute(attribute?: { name: string; slug: string } | null): boolean {
  if (!attribute) return false;
  const slug = (attribute.slug || '').trim().toLowerCase();
  const name = (attribute.name || '').trim().toLowerCase();
  const key = `${slug} ${name}`;
  return (
    slug === 'format' ||
    slug === 'formats' ||
    slug.includes('format-access') ||
    slug.includes('access-type') ||
    name.includes('format') ||
    name.includes('access type') ||
    /\baccess\b/.test(key)
  );
}

export function isImprintAttribute(attribute?: { name: string; slug: string } | null): boolean {
  if (!attribute) return false;
  const slug = (attribute.slug || '').trim().toLowerCase().replace(/_/g, '-');
  const name = (attribute.name || '')
    .trim()
    .toLowerCase()
    .replace(/™/g, '')
    .replace(/\s+/g, ' ');
  const key = slug || name;
  if (key === 'imprint' || key === 'imprints') return true;
  if (slug.startsWith('imprint-') || slug.includes('imprint')) return true;
  return /\bimprints?\b/.test(name);
}

export function isStateAttribute(attribute?: { name: string; slug: string } | null): boolean {
  if (!attribute) return false;
  const key = (attribute.slug || attribute.name).trim().toLowerCase();
  if (
    key === 'state' ||
    key === 'states' ||
    key.startsWith('state-') ||
    key.includes('state-region')
  ) {
    return true;
  }

  const name = attribute.name.trim().toLowerCase();
  return (
    name === 'state' ||
    name === 'states' ||
    name.includes('state / region') ||
    name.includes('state/region')
  );
}

export function isRegionAttribute(attribute?: { name: string; slug: string } | null): boolean {
  if (!attribute) return false;
  const key = (attribute.slug || attribute.name).trim().toLowerCase();
  if (key === 'region' || key === 'regions' || key.startsWith('region-')) {
    return true;
  }

  const name = attribute.name.trim().toLowerCase();
  return name === 'region' || name === 'regions';
}
